import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/app.state';
import { Observable, combineLatest } from 'rxjs';
import { ChangeMenuActive, OPEN_FILTER_BAR, OPEN_SEARCH_BAR, CLOSE_SEARCH_BAR } from '../../../../store/menu/menu.action';
import { ReservationsService } from '../../../service/reservations/reservations.service';
import { ModelStore } from '../../../../shared/model.store';
import { DealsService } from '../../../service/deals/deals.service';
import { LocalStorageUtils } from 'src/app/shared/util/local-storage.utils';
import { StoreType, SupportedLocation } from '../../../model/dispensary/dispensary-dsp.model';

@Component({
  selector: 'app-public-layout-header',
  templateUrl: './public-layout-header.component.html',
  styleUrls: ['./public-layout-header.component.scss']
})
export class PublicLayoutHeaderComponent implements OnInit {

  id: any;
  numberItem = 0;
  loginStatus: any;
  activeButton = 1;
  @Output()
  openLoginForm = new EventEmitter<any>();

  authState: Observable<any>;
  menu$: Observable<any>;
  dispId: string;

  searchBarStatus = false;
  filterStatus = false;
  activeMenu = '';
  reservationState: Observable<any>;
  firtLoginFlg = false;
  shouldShowDealsButton = true;
  supportedLocations: SupportedLocation[];
  showDeliveryWarning = false;
  shouldShowSupportedZipCodes = false;
  supportedZipCodes: string[];
  userId: number;
  WARNING_TEXT = 'Please add an address in delivery area!';
  combinedAddressesLocations = combineLatest(
    this.modelStore.addressesObservable,
    this.modelStore.supportedLocationsObservable
  );
  combineAuthDispensary = combineLatest(
    this.modelStore.dispensaryObservable,
    this.store.select('authentication')
  );

  constructor(
    private router: Router,
    private reservationsService: ReservationsService,
    private dealsService: DealsService,
    private modelStore: ModelStore,
    private store: Store<AppState>
  ) {}

  ngOnInit() {
    this.combineAuthDispensary.subscribe(latestValues => {
      const [dispensary, authState] = latestValues;
      if (dispensary['disp_id'] && authState.isAuthenticated){
        this.dispId = dispensary['disp_id'];
        this.getCart(this.dispId);
      }
    });

    this.authState = this.store.select('authentication');
    this.authState.subscribe(auth => {
      this.loginStatus = auth.isAuthenticated;
      if (this.loginStatus) this.modelStore.getAddresses(auth['profile']['user_id'], null);
      this.firtLoginFlg = true;
      setTimeout(() => {
        if (!auth.isAuthenticated) {
          this.numberItem = LocalStorageUtils.getItem('GL_CART_NOT_LOGIN') ?
            JSON.parse(LocalStorageUtils.getItem('GL_CART_NOT_LOGIN')).length : 0;
        }
      }, 3000);
    });
    this.menu$ = this.store.select('menu');
    this.menu$.subscribe(menu => {
      this.searchBarStatus = menu.searchBarStatus;
      this.filterStatus = menu.filterStatus;
      this.activeMenu = menu.activeMenu;
      this.id = menu.disp_id;
      if (this.id){
        this.modelStore.getSupportedLocations(this.id);
        this.getDispensary(this.id);
      }
    });
    this.reservationState = this.store.select('reservation');

    if (this.firtLoginFlg && this.loginStatus) {
      this.reservationState.subscribe(reservationState => {
        this.numberItem = reservationState.numberProduct;
      });
      this.firtLoginFlg = false;
    }
    
    if (!this.loginStatus) {
      this.numberItem = LocalStorageUtils.getItem('GL_CART_NOT_LOGIN') ?
        JSON.parse(LocalStorageUtils.getItem('GL_CART_NOT_LOGIN')).length : 0;
    }

    this.reservationState.subscribe(rs => {
      if (!this.loginStatus){
        this.numberItem = LocalStorageUtils.getItem('GL_CART_NOT_LOGIN') ? JSON.parse(LocalStorageUtils.getItem('GL_CART_NOT_LOGIN')).length : 0;
      }
      else if (rs && rs['numberProduct']){
        this.numberItem = rs['numberProduct'];
      }
    });
  }

  getDispensary(dispId: number) {
    this.dealsService.getDispensary(dispId).subscribe(rs => {
      if (rs['deal_categories'] && rs['deal_categories'].length == 0){
        this.shouldShowDealsButton = false;
      }

      if (rs['dispensary'] && rs['dispensary']['store_type'] == StoreType.Delivery){
        this.combinedAddressesLocations.subscribe(latestValues => {
          const [addresses, supportedLocations] = latestValues;
          const userZipCodes = addresses.map(address => address.zip_code);
          const deliveryZipCodes = supportedLocations.map(supportedLocation => supportedLocation.zip_code);

          if (!this.loginStatus || userZipCodes.length == 0 || !this.isUserInDeliveryArea(userZipCodes, deliveryZipCodes)){
            this.showDeliveryWarning = true;
            this.supportedZipCodes = deliveryZipCodes;
          } 
          else {
            this.showDeliveryWarning = false;
          }
        });
      }
    });
  } 

  isUserInDeliveryArea(userZipCodes: string[], dispensaryZipCodes: string[]){
    return userZipCodes.find(userZipCode => dispensaryZipCodes.includes(userZipCode));
  }

  mergeCartAfterLogin() {
    if (!LocalStorageUtils.getItem('GL_CART_NOT_LOGIN')) {
      return;
    }
    const product_ids = [];
    JSON.parse(LocalStorageUtils.getItem('GL_CART_NOT_LOGIN')).forEach(element => {
      product_ids.push({ product_id: element });
    });
    const data = { product_ids: product_ids, removed_ids: [], disp_id: this.dispId };
    this.reservationsService.addToCart(data).subscribe(rs => {
      if (rs && rs['cart'] && rs['cart']['items']){
        this.numberItem = rs['cart']['items'].length;
        LocalStorageUtils.removeItem('GL_CART_NOT_LOGIN');
      }
    });
  }

  getCart(dispId: string) {
    this.mergeCartAfterLogin();
    return this.reservationsService.getCart(dispId).subscribe(rs => {
      let numberItem = 0;
      if (rs && rs['cart']) {
        if (rs && rs['cart']['items']) {
          rs['cart']['items'].forEach(item => {
            numberItem = numberItem + Number(item.qty);
          });
        }
        if (rs && rs['cart']['deals']) {
          numberItem = numberItem + rs['cart']['deals'].length;
        }
        if (rs && rs['cart']['reward_items']) {
          numberItem = numberItem + rs['cart']['reward_items'].length;
        }
      }
      this.numberItem = numberItem;
    });
  }

  showLogin() {
    this.openLoginForm.emit();
  }

  onNavigateToShowDeals(tabIndex) {
    this.activeButton = tabIndex;
    this.store.dispatch(new ChangeMenuActive({ activeMenu: 'deals' }));
    this.router.navigate([`${this.id}/deals`]);
  }

  onNavigateToShowMenu(tabIndex) {
    if (this.searchBarStatus) {
      this.store.dispatch({ type: CLOSE_SEARCH_BAR });
    }
    else {
      
    }
    this.activeButton = tabIndex;
    this.store.dispatch(new ChangeMenuActive({ activeMenu: 'menu' }));
    this.router.navigate([`${this.id}/menu`]);
  }

  onNavigateToAccount() {
    if (this.loginStatus) {
      this.store.dispatch(new ChangeMenuActive({ activeMenu: 'account' }));
      this.router.navigate([`${this.id}/account`]);
    } else {
      this.showLogin();
    }
  }

  onNavigateToReservation() {
    if (this.loginStatus) {
      if (this.numberItem > 0) {
        this.store.dispatch(new ChangeMenuActive({ activeMenu: 'reservation' }));
        this.router.navigate([`${this.id}/reservation`]);
      }
    } else {
      this.showLogin();
    }
  }

  changeSearchBarStatus() {
    this.router.navigate([`${this.id}/menu`]);
    this.store.dispatch({ type: OPEN_SEARCH_BAR });
  }

  changeFilterBarStatus() {
    this.router.navigate([`${this.id}/menu`]);
    this.store.dispatch({ type: OPEN_FILTER_BAR });
  }

  showSupportedZipCodes() {
    this.shouldShowSupportedZipCodes = true;
  }

  closePopup() {
    this.shouldShowSupportedZipCodes = false;
  }
}
